module.exports = __webpack_public_path__ + "img/1.73f214ad.jpg";